import { PAYMENT_METHODS, SERVICES } from '@autopass-web/domain';

import Client from '../client';

import type { ConfirmPaymentInfo, PaymentInfo, Receipt } from './types';

interface ConfirmJkoPayTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmJkoPayTransaction = async ({
  confirmPaymentInfo,
}: ConfirmJkoPayTransactionProps) => {
  const { data } = await Client.authApsWalletPay({
    transactionId: confirmPaymentInfo.merchantTransactionId,
    walletType: 'jkopay',
  });

  return data;
};

interface CreateJkoPaySessionProps {
  paymentInfo: PaymentInfo;
  receipt: Receipt;
  email: string | undefined;
}

export const createJkoPaySession = async ({
  paymentInfo,
  receipt,
  email,
}: CreateJkoPaySessionProps) => {
  const callbackUrlParams = new URLSearchParams({
    paymentType: PAYMENT_METHODS.JKOPAY,
    serviceType: SERVICES.APS,
    parkingTicketId: paymentInfo.id,
    plateNumber: paymentInfo.plateNumber,
  });

  const callbackUrl = `${
    window.location.origin
  }/auth?${callbackUrlParams.toString()}`;

  const { data } = await Client.createWalletSession({
    callbackUrl,
    parkingTicketId: paymentInfo.id,
    email,
    receipt,
    walletType: 'jkopay',
  });

  return data.data.redirect_link;
};
